import React, { useContext, useEffect, useState } from "react"
import { KopyProtectUpgradeCards } from "../components/protect/KopyProtectUpgradeCards.jsx"
import { TopMenu } from "../components/TopMenu.jsx"
import { UpgradeProtectModal } from "../components/protect/UpgradeProtectModal.jsx"
import { GlobalStateContext } from "../components/providers/GlobalStateProvider.jsx"
import { useNavigate } from "react-router-dom"
import { usePostHog } from "posthog-js/react"

const UpgradeProtect = () => {
	const posthog = usePostHog()
	const { state } = useContext(GlobalStateContext)
	const navigate = useNavigate()
	const [upgradeModalIsOpen, setUpgradeModalIsOpen] = useState(false)

	const openUpgradeModal = () => {
		setUpgradeModalIsOpen(true)
	}

	useEffect(() => {
		if (state.hasValidKopyProtectSubscription) {
			navigate("/")
		} else {
			posthog?.capture("user_visits_upgrade_protect_page_v2")
		}
	}, [state.kopyProtectSubscription])

	return (
		<div>
			<TopMenu goBack="/" storeSelector />

			<div
				style={{
					height: "100%",
					padding: "1rem",
					paddingTop: "5rem",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					gap: "1rem",
				}}
			>
				<KopyProtectUpgradeCards onUpgradeClick={openUpgradeModal} />
			</div>

			<UpgradeProtectModal
				open={upgradeModalIsOpen}
				setOpen={setUpgradeModalIsOpen}
			/>
		</div>
	)
}

export default UpgradeProtect
